import {
  COLOR_NEUTRAL_SIX,
  COLOR_PRIMARY_DARK,
  COLOR_PRIMARY_PALE,
  COLOR_QUATERNARY_DARK,
  COLOR_QUATERNARY_PALE,
  COLOR_SECONDARY_DARK,
  COLOR_SECONDARY_PALE,
  COLOR_TERTIARY_PALE,
  GRID_GUTTER_WIDTH,
} from '@myre/common-styles';

import { Directive, HostBinding, Input } from '@angular/core';

/**
 * @deprecated Use `BannerComponent` instead
 */
export type Color = 'blue' | 'red' | 'yellow' | 'green';

/**
 * @deprecated Use `BannerComponent` instead
 */
export type ColorOrType = Color | 'info' | 'error' | 'warn' | 'success';

/**
 * @deprecated Use `BannerComponent` instead
 */
@Directive({ selector: '[myreBanner]' })
export class BannerDirective {
  @Input()
  public set color(color: ColorOrType) {
    switch (color) {
      case 'info': {
        this._color = 'blue';

        break;
      }
      case 'error': {
        this._color = 'red';

        break;
      }
      case 'warn': {
        this._color = 'yellow';

        break;
      }
      case 'success': {
        this._color = 'green';

        break;
      }
      default: {
        this._color = color;
      }
    }
  }

  @HostBinding('style.background-color')
  public get backgroundColor(): string {
    switch (this._color) {
      case 'green': {
        return COLOR_PRIMARY_PALE;
      }
      case 'red': {
        return COLOR_SECONDARY_PALE;
      }
      case 'blue': {
        return COLOR_TERTIARY_PALE;
      }
      case 'yellow': {
        return COLOR_QUATERNARY_PALE;
      }
      default:
        return COLOR_TERTIARY_PALE;
    }
  }

  @HostBinding('style.color')
  public get textColor(): string {
    switch (this._color) {
      case 'green': {
        return COLOR_PRIMARY_DARK;
      }
      case 'red': {
        return COLOR_SECONDARY_DARK;
      }
      case 'blue': {
        return COLOR_NEUTRAL_SIX;
      }
      case 'yellow': {
        return COLOR_QUATERNARY_DARK;
      }
      default:
        return COLOR_NEUTRAL_SIX;
    }
  }

  @HostBinding('style.padding.px')
  public padding: number = GRID_GUTTER_WIDTH;

  @HostBinding('style.border-radius')
  public borderRadius: string = '2px';

  private _color: Color;
}
